export default __webpack_public_path__ + "static/media/anjeloOpen.02e1bb74.jpg";